const NAMING_ID = ['GlobalID', 'ID'];

export const isNamingID = (name: string) => {
  return NAMING_ID.includes(name);
};
